import { FormattedMessage } from "react-intl";

import { useOnlyOnce } from "@nens/react/hooks";

import { RanaInfoBox } from "../../lib/components/rana-info-box";
import { ClearlyHookReturnIsClearly } from "../hooks/use-clearly-subscription";

import { AuthLoader } from "./auth-loader";

interface ClearlyAuthRedirectProps extends ClearlyHookReturnIsClearly {
  logOut: () => void;
}

export const ClearlyAuthRedirect = ({
  redirectOrPostToClearly,
  errors,
  logOut,
}: ClearlyAuthRedirectProps) => {
  useOnlyOnce(redirectOrPostToClearly);

  if (errors)
    <RanaInfoBox
      title={
        <FormattedMessage id="heading.clearlyLoginFailed" defaultMessage="Clearly login failed" />
      }
      errors={errors}
      button={{
        text: <FormattedMessage id="button.signout" defaultMessage="Sign out" />,
        onClick: logOut,
      }}
    />;

  return <AuthLoader />;
};
